export default function () {
  if (document.querySelector('.PageMain--product-page .ProductPage')) {
    import(/* webpackChunkName: "product-page-module" */ './product-page').then(
      (module) => {
        const ProductPage = module.default
        ProductPage()
      }
    )
  }
}
